import { getSpApi, requestConfig } from "./apiRoot";
import { UrlManager } from "./UrlManager";

export const requestGreenCard = async (request: {
    vehicleId: number;
    params: {
        policyholderId: number;
        ibpAclId: number;
    };
}): Promise<Paths.ApiRequestGreencard$VehicleId.Post.Responses.$200> => {
    const { vehicleId, params } = request;

    const axiosRequestConfig = requestConfig<Paths.ApiRequestGreencard$VehicleId.Post.QueryParameters>({
        params,
    });

    const { data } = await getSpApi().post(UrlManager.greenCard(vehicleId), null, axiosRequestConfig);
    return data;
};
